module.exports = __webpack_public_path__ + "static/media/default-user.4cba9491.svg";